import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export function Input({
  label,
  error,
  helperText,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-365">
      {label && <label className="block text-xs font-medium text-[#6B6B7E] mb-1.5 uppercase tracking-widest" data-id="element-366">
          {label}
        </label>}
      <input className={`
          w-full bg-[#1A1A1E] border rounded-lg px-3.5 py-2.5 text-sm text-[#F0F0F0]
          placeholder-[#6B6B7E]/40 font-mono
          focus:outline-none focus:ring-1 focus:border-[#00D4C8] focus:ring-[#00D4C8]/20
          transition-all duration-200
          ${error ? 'border-[#EF4444] focus:ring-[#EF4444]/20' : 'border-[#2A2A32]'}
          ${className}
        `} {...props} data-id="element-367" />
      {error && <p className="mt-1.5 text-xs text-[#EF4444]" data-id="element-368">{error}</p>}
      {helperText && !error && <p className="mt-1.5 text-xs text-[#6B6B7E]" data-id="element-369">{helperText}</p>}
    </div>;
}